import React from "react";
// import generateCards from "../../assets/pic/generateCards.png";
// import buildreceipient from "../../assets/pic/buildreceipient.png";
// import wemailit from "../../assets/pic/wemailit.png";
// import routeLine from "../../assets/pic/routeLine.png";
import howItWorks1 from "../../assets/icons/hiw1.svg";
import howItWorks2 from "../../assets/icons/hiw2.svg";
import howItWorks3 from "../../assets/icons/hiw3.svg";
import { LayoutForLandingPage } from "./Home";
const HowitWorks = () => {
  return (
    <LayoutForLandingPage>
      <div className="my-10 md:my-16 lg:my-10 py-3">
        <h2 className="text-center font-semibold text-3xl md:text-5xl">
          How it <span className="text-[#F66061]">Works</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-4 text-center mx-auto max-w-7xl">
  {/* Step 1 */}
  <div className="text-lg md:text-xl">
    <div className="mx-auto p-5 border border-[#3649571A]  border-opacity-20 w-fit rounded-full my-4">
      <img
        src={howItWorks2}
        alt="How It Works 1"
        className="h-14 w-14 md:h-16 md:w-16 p-2"
      />
    </div>
    <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold font-shadows">
      Build Your Recipient Profile
    </h3>
    <p className="text-base md:text-lg mt-1">
      Build your recipient's profile by telling us a bit about them.
    </p>
  </div>

  {/* Step 2 */}
  <div className="text-lg md:text-xl">
    <div className="mx-auto p-5 border border-[#3649571A] border-opacity-20 w-fit rounded-full my-4">
      <img
        src={howItWorks3}
        alt="How It Works 2"
        className="h-14 w-14 md:h-16 md:w-16"
      />
    </div>
    <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold font-shadows">
      Generate Your Cards
    </h3>
    <p className="text-base md:text-lg mt-1">
      Based on the profile and message theme, we will generate the cards
      and messages for you.
    </p>
  </div>

  {/* Step 3 */}
  <div className="text-lg md:text-xl">
    <div className="mx-auto p-5 border border-[#3649571A]  border-opacity-20 w-fit rounded-full my-4">
      <img
        src={howItWorks1}
        alt="How It Works 3"
        className="h-14 w-14 md:h-16 md:w-16"
      />
    </div>
    <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold font-shadows">
      We Mail It
    </h3>
    <p className="text-base md:text-lg mt-1">
      Pick your favorite cards, and based on the event date, we'll mail
      it for you!
    </p>
  </div>
</div>

      </div>
    </LayoutForLandingPage>
  );
};

export default HowitWorks;
{
  /* <div className="my-20">
  <h2 className="text-center md:text-5xl text-3xl">How it works</h2> */
}
{
  /* </div> */
}
{
  /* <div className="relative flex lg:flex-row flex-col items-center justify-center lg:gap-10 gap-20">
  <div className="absolute bg-transparent top-44 hidden lg:block">
    <img src={routeLine} alt=""></img>{" "}
  </div>
  <div className="text-center flex flex-col justify-center items-center md:text-xl text-lg gap-y-2">
    <img src={buildreceipient} alt="HowItWorks1" className="mb-5" />
    <h3 className="text-2xl font-semibold mt-3">
      1. Build your recipient profile
    </h3>
    <p className="p-2">
      Build your recipients profile, by telling us <br /> a bit about them
    </p>
  </div>
  <div className="text-center flex lg:flex-col flex-col-reverse justify-center items-center md:text-xl text-lg gap-y-2">
    <div>
      <h3 className="text-2xl font-semibold mt-10">
        2. Generate your cards
      </h3>
      <p className="p-2">
        Based on the profile and message theme, we will <br /> generate
        the cards and messages for you
      </p>
    </div>
    <img src={generateCards} alt="HowItWorks2" className="mt-4" />
  </div>
  <div className="text-center flex flex-col justify-center items-center md:text-xl text-lg gap-y-2">
    <img src={wemailit} alt="HowItWorks3" className="" />
    <h3 className="text-2xl font-semibold mt-8  ">3. We mail it</h3>
    <p className="p-2">
      Pick your favorite cards and based on <br /> the event date, we'll
      mail it for you!
    </p>
  </div>
</div> */
}
